import React from "react";

import styles from './Footer.module.css';
import logo from "../../images/LogoAsl.svg";

export function Footer() {

    return (
        <footer className={styles.footer}>
            <div>&copy; 2024 Tzion MyResult 2024.001.01.08</div>
            <img src={logo} alt="Logo da ASL" />
        </footer>
    );
}